import moment from 'moment-timezone';
import type { RangeExport } from '@/trendData/duration.types';

/**
 * Converts a stored range to UTC moments and its duration. Builds new moments on every call. Kept apart from
 * duration.utilities so the duration store can use it without importing the legacy store singletons.
 */
export const toRangeExport = (start: number, end: number): RangeExport => ({
  start: moment.utc(start),
  end: moment.utc(end),
  duration: moment.duration(end - start),
});
